import { render, staticRenderFns } from "./Afiche.vue?vue&type=template&id=7deaad17&"
import script from "./Afiche.vue?vue&type=script&lang=js&"
export * from "./Afiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports